export default __webpack_public_path__ + "static/kabina-d930bd0e380e01aef9f985587b5e4768.jpg";